import Text from 'components/Text/Text';
import React, { useContext, useEffect, useState } from 'react';
import { Input } from 'antd';
import { ICustomerLocalizationItem } from 'types';
import { useTranslation } from 'react-i18next';
import { ILocalizationContext, LocalizationContext } from '../../../../../../../localizationState/localizationContext';
import classNames from 'classnames';
import style from './LocalizationItem.module.scss';

interface ILocalizationItem {
	groupId: string;
	itemData: ICustomerLocalizationItem;
	languageId: string;
	isRequired?: boolean;
}

const LocalizationItem: React.FC<ILocalizationItem> = ({ groupId, itemData, languageId, isRequired }) => {
	const { invalidFields, useCustomerSettings } = useContext<ILocalizationContext>(LocalizationContext);
	const [localValue, setLocalValue] = useState<string | undefined>(undefined);
	const [isTouched, setIsTouched] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);
	const { t } = useTranslation('form');

	const errorClasses = classNames(style.error, { [style.errorVisible]: error && !localValue && isRequired });

	const translationData = itemData.translations.find((el) => el.languageId === languageId);
	const fieldName = `${groupId}/${itemData.key}/${languageId}/${isRequired}`;

	useEffect(() => {
		if (!localValue && isTouched && isRequired) {
			setError(true);
		}
	}, [isTouched, localValue, isRequired]);

	useEffect(() => {
		if (invalidFields.some((el) => el === fieldName)) {
			setError(true);
		}
	}, [invalidFields, fieldName]);

	useEffect(() => {
		if (translationData?.value) {
			setLocalValue(translationData?.value);
		}
	}, [translationData?.value]);

	const handleInput = () => {
		setError(false);
		setIsTouched(true);
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setLocalValue(e.target.value);
	};

	return (
		<div className={style.container}>
			<Text
				className={style.fieldHeader}
				translationNameSpace="localizationSettings"
				translationKey={itemData.key}
				theme="neutralLight"
				size="s"
			/>
			<div className={style.inputContainer}>
				<Input
					className={style.input}
					name={fieldName}
					value={localValue}
					disabled={useCustomerSettings}
					onInput={handleInput}
					onChange={handleChange}
					placeholder={t('inputPlaceholder')}
				/>
			</div>
			<Text
				className={errorClasses}
				translationNameSpace="error"
				translationKey="enterValue"
				theme="error"
				size="s"
			/>
		</div>
	);
};

export default LocalizationItem;
